// extracted by mini-css-extract-plugin
module.exports = {"TextareaField__label":"ua_a"};